import Vue from 'vue'
import Vuex from 'vuex'

import { fetchHttpData as $fetchHttpData } from '@/config/network/httpService'
// import globalMixin from '@/mixin/globalMixin'

// import { isNaN } from 'lodash'

const getName = () => {
  return 'custCntr'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        menuData: [],
        siteMenuSno: Object
      },
      getters: {
        menuData: state => {
          return state.menuData
        },
        siteMenuSno: state => {
          return state.siteMenuSno
        }

      },
      mutations: {
        SET_MENU_DATA (state, value) {
          state.menuData = value
        },
        // 클릭한 메뉴 SNO
        SITE_MENU_SNO (state, value) {
          state.siteMenuSno = value
        }
      },
      actions: {
        async ACT_TEXT_MENU_LIST ({commit, state}, payload) {
          const result = await $fetchHttpData(payload.http, 'selectMobileMenuList', payload.param)

          if (result.status === 'OK') {
            // state에 저장
            commit('SET_MENU_DATA', result.data.menuList)
            if (payload.callback) {
              payload.callback(result)
            }
          }
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/nrw/custCntr.js